import {
  FilterOnEmptyState,
  LiveFeedback,
  LoadingSpinner,
  NoFlyersAvailableEmptyState,
} from '@/components';
import { FlyerList } from '@/components/FlyerboardPagination/FlyerList';
import { JAR_TAG_FILTERS } from '@/context/JarFlyerboardProvider';
import { OwningTypeEnum } from '@/graphql/types';
import { useJarFlyerboardPagination, useLiveFeedback, useURLSearchParams } from '@/hooks';
import { css } from '@emotion/css';
import { useSearchParams } from 'react-router-dom';

export const EmbeddedJarList = () => {
  const { audienceId, districtId, audienceType, sortBy } = useURLSearchParams();
  const [liveMessage, setLiveMessage] = useLiveFeedback({ delay: 2500 });
  const [searchParams, setSearchParams] = useSearchParams();
  const filterParam = searchParams.get('filter');
  const owningType =
    filterParam === JAR_TAG_FILTERS.SCHOOL
      ? OwningTypeEnum.district
      : filterParam === JAR_TAG_FILTERS.COMMUNITY
      ? OwningTypeEnum.organization
      : undefined;
  const isCommunityFree = filterParam === JAR_TAG_FILTERS.FREE ? true : undefined;
  const hasFilter = filterParam !== null && filterParam !== 'all';

  const { flyers, loading, fetchMoreFlyers, total } = useJarFlyerboardPagination({
    audienceId,
    districtId,
    flyerboardFilters: {
      schoolIds: audienceType === 'school' ? [Number(audienceId)] : [],
      owningType,
      isCommunityFree,
      allDistrictSchools: audienceType === 'district' ? true : undefined,
    },
    sortBy: sortBy ?? undefined,
    skipExpandedCommunityFlyers: true,
  });

  const resetFilters = () => {
    searchParams.set('filter', 'all');
    setSearchParams(searchParams, { replace: true });
    setLiveMessage('Filters reset.');
  };

  const EmptyState = () => {
    if (flyers.length === 0 && !loading) {
      if (hasFilter) {
        return <FilterOnEmptyState onClick={resetFilters} />;
      }

      return <NoFlyersAvailableEmptyState />;
    }
    return null;
  };

  return (
    <main className={cn.container}>
      <LiveFeedback message={liveMessage} />
      {loading && flyers.length === 0 && <LoadingSpinner />}
      <EmptyState />
      {flyers.length > 0 && (
        <>
          <FlyerList
            flyers={flyers}
            nextPage={fetchMoreFlyers}
            total={total}
            trackId="jar"
            audienceId={audienceId}
            districtId={districtId}
            trackingEventFrom="jar"
            showTags
            isEmbedded={true}
          />
        </>
      )}
    </main>
  );
};

const cn = {
  container: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    flex-grow: 10;
    padding-top: 24px;
  `,
};
